// Banner.js
import React, { useRef, useState } from "react";
import { Button, Carousel, Col, Container, Image, Row } from "react-bootstrap";
import { ImageBannerCss } from "./ImageBannerCss";
import "./ImageBanner.css";
import { Link } from "react-router-dom";

interface ActionButtonI {
  title: string;
  href: string;
}

interface ImagebannerI {
  imgSrc: string;
  mainText?: string;
  subText?: string;
  actionButton?: ActionButtonI;
  carousel?: Boolean;
  videoSrc?: string;
}

const ImageBanner = (content: ImagebannerI) => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [paused, setPaused] = useState(false);
  const [showPaused, setShowPaused] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const handleSelect = (selectedIndex: number) => {
    setActiveIndex(selectedIndex);
  };

  const togglePlay = () => {
    if (videoRef?.current) {
      console.log(videoRef?.current)
      if (isPlaying) {
        //@ts-ignore
        videoRef?.current?.pause();
      } else {
        //@ts-ignore
        videoRef?.current?.play();
      }
      setIsPlaying(!isPlaying);
      setPaused(!paused)
    }
  };

  return (
    <div
      className="banner-area bg-black"
      style={{
        position: "relative",
        paddingTop: content.mainText ? "50px" : "0px"
      }}
    >
      {content.carousel ? (
        <>
          <Carousel activeIndex={activeIndex} onSelect={handleSelect} interval={activeIndex == 1 ? 22000 : 3000} style={{ paddingTop: '88px' }}>
            <Carousel.Item style={{ maxHeight: '70vh' }}>
              <video muted ref={videoRef} width="100%" height="100%" autoPlay loop>
                <source src={content.videoSrc} type="video/mp4"></source>
              </video>
              <button style={{ display: showPaused ? 'block' : 'none' }} className="play-button" onClick={togglePlay}>
                {isPlaying ? '⏸' : '▶'}
              </button>
              <Carousel.Caption>
                <h3>HOME OF SPORTS</h3>
                <h5>Your destination for collegiate sports</h5>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <Image src={content.imgSrc} fluid alt="" width={"100%"} />
              <Carousel.Caption>
                <h3>CUTTING EDGE AI BASED ANALYTICS</h3>
                <h5>Analysing games using proprietary computer vision techniques</h5>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <Image src={'/hero_soccer_3.jpg'} fluid alt="" width={"100%"} />
              <Carousel.Caption>
                <h3>BEST IN CLASS AUTOMATED PRODUCTION</h3>
                <h5>Full-HD and 180 degree live broadcast and recordings</h5>
              </Carousel.Caption>
            </Carousel.Item>
          </Carousel>
        </>
      ) : (
        <Container fluid>
          <div className={content.mainText ? "series-banner-img" : ""}>
            <Image src={content.imgSrc} fluid alt="" width={"100%"} />
          </div>
        </Container>
      )}

      {content.mainText ? (
        <Container
          className={"main-container"}
          style={ImageBannerCss.textOverlay}
        >
          <div>
            <h1 className="title animated" style={ImageBannerCss.title}>
              {content.mainText}
            </h1>
            <Row className="combo-pack-price" style={ImageBannerCss.subText}>
              <Col>{content.subText}</Col>
            </Row>
            <Row className="slider-button">
              <Col>
                <Button
                  style={ImageBannerCss.button}
                  className="btn-style-hm4 animated btn-danger"
                >
                  <Link
                    to={content?.actionButton?.href ?? "#"}
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    {content?.actionButton?.title}
                  </Link>
                </Button>
              </Col>
            </Row>
          </div>
        </Container>
      ) : null}
    </div>
  );
};

export default ImageBanner;
